const API_BASE = '/api';
let token = localStorage.getItem('dakara_token');
export function setToken(t) { token = t; if (t) localStorage.setItem('dakara_token', t); else localStorage.removeItem('dakara_token'); }
export function getToken() { return token || localStorage.getItem('dakara_token'); }

// Fichiers protégés (audio, PDF) : téléchargés avec l'en-tête d'authentification, jamais avec le jeton dans l'adresse
export async function blobProtege(url) {
  const t = getToken();
  const r = await fetch(url, { headers: t ? { Authorization: `Bearer ${t}` } : {} });
  if (r.status === 401) { setToken(null); window.location.reload(); throw new Error('Session expirée'); }
  if (!r.ok) throw new Error('Fichier introuvable');
  return URL.createObjectURL(await r.blob());
}
export async function ouvrirProtege(url) {
  const w = window.open('', '_blank');   // ouverte tout de suite, pendant le clic, sinon le navigateur bloque la fenêtre
  try { const u = await blobProtege(url); if (w) w.location.href = u; else window.location.assign(u); }
  catch (e) { if (w) w.close(); alert(e.message); }
}

async function request(path, options = {}) {
  const t = getToken();
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}), ...options.headers } });
  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : {}; } catch(e) { throw new Error('Réponse invalide du serveur'); }
  if (res.status === 401 && !path.startsWith('/auth/')) { setToken(null); window.location.reload(); throw new Error('Session expirée'); }
  if (!res.ok) { const err = new Error(data.error || 'Erreur serveur'); err.data = data; throw err; }
  return data;
}

// Helper streaming NDJSON
async function ndjsonStream(path, body, onEvent) {
  const t = getToken();
  const r = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) },
    body: body ? JSON.stringify(body) : undefined
  });
  if (!r.ok && r.status !== 200) {
    let msg = `HTTP ${r.status}`;
    try { const j = await r.json(); if (j.error) msg = j.error; } catch(e) {}
    throw new Error(msg);
  }
  const reader = r.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let nl;
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl);
      buffer = buffer.slice(nl + 1);
      if (!line.trim()) continue;
      try { onEvent(JSON.parse(line)); } catch(e) { console.error('Parse NDJSON line:', e, line.slice(0,100)); }
    }
  }
  if (buffer.trim()) {
    try { onEvent(JSON.parse(buffer)); } catch(e) {}
  }
}

export const api = {
  login: (u, p) => request('/auth/login', { method: 'POST', body: JSON.stringify({ username: u, password: p }) }),
  // Double authentification
  verifier2fa: (ticket, code, se_souvenir) => request('/auth/2fa', { method: 'POST', body: JSON.stringify({ ticket, code, se_souvenir }) }),
  configurer2fa: (ticket, code, se_souvenir) => request('/auth/2fa/configurer', { method: 'POST', body: JSON.stringify({ ticket, code, se_souvenir }) }),
  getSecurite: () => request('/securite'),
  saveSecurite: (d) => request('/securite', { method: 'PUT', body: JSON.stringify(d) }),
  getAppareils: (userId) => request(`/users/${userId}/appareils`),
  revoquerAppareil: (userId, appId) => request(`/users/${userId}/appareils/${appId}`, { method: 'DELETE' }),
  reinitialiser2fa: (userId) => request(`/users/${userId}/2fa/reinitialiser`, { method: 'POST' }),
  me: () => request('/auth/me'),
  dashboardStats: () => request('/dashboard/stats'),
  // Clients
  getClients: (search) => request(`/clients${search ? `?search=${encodeURIComponent(search)}` : ''}`),
  getClient: (id) => request(`/clients/${id}`),
  createClient: (d) => request('/clients', { method: 'POST', body: JSON.stringify(d) }),
  updateClient: (id, d) => request(`/clients/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteClient: (id) => request(`/clients/${id}`, { method: 'DELETE' }),
  // Contrats
  getContrats: (p = {}) => { const qs = Object.entries(p).filter(([,v]) => v).map(([k,v]) => `${k}=${encodeURIComponent(v)}`).join('&'); return request(`/contrats${qs ? `?${qs}` : ''}`); },
  getContrat: (id) => request(`/contrats/${id}`),
  getContratPdfUrl: (id) => `${API_BASE}/contrats/${id}/pdf`,
  createContrat: (d) => request('/contrats', { method: 'POST', body: JSON.stringify(d) }),
  updateContrat: (id, d) => request(`/contrats/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  setContratStatut: (id, statut) => request(`/contrats/${id}/statut`, { method: 'PATCH', body: JSON.stringify({ statut }) }),
  renouvelerContrat: (id) => request(`/contrats/${id}/renouveler`, { method: 'POST' }),
  deleteContrat: (id) => request(`/contrats/${id}`, { method: 'DELETE' }),
  getCorbeille: () => request('/contrats-corbeille'),
  restoreContrat: (id) => request(`/contrats-corbeille/${id}/restore`, { method: 'POST' }),
  deleteContratPermanent: (id) => request(`/contrats-corbeille/${id}`, { method: 'DELETE' }),
  // Rappels
  getRappels: () => request('/rappels'),
  updateRappel: (id, data) => request(`/rappels/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  createRappel: (data) => request('/rappels', { method: 'POST', body: JSON.stringify(data) }),
  deleteRappel: (id) => request(`/rappels/${id}`, { method: 'DELETE' }),
  getRappelsConfig: () => request('/rappels/config'),
  getRappelAudioUrl: (id) => `${API_BASE}/rappels/${id}/audio`,
  testImap: () => request('/rappels/test-imap', { method: 'POST' }),
  // Chorus
  getChorus: () => request('/chorus'),
  addChorus: (data) => request('/chorus', { method: 'POST', body: JSON.stringify(data) }),
  updateChorus: (id, data) => request(`/chorus/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteChorus: (id) => request(`/chorus/${id}`, { method: 'DELETE' }),
  // Axonaut stock management
  axonautSearchProducts: (search) => request(`/axonaut/products${search?`?search=${encodeURIComponent(search)}`:''}`),
  axonautGetStock: (id) => request(`/axonaut/products/${id}/stock`),
  axonautUpdateStock: (id, data) => request(`/axonaut/products/${id}/stock`, { method: 'PATCH', body: JSON.stringify(data) }),
  axonautHistory: (params) => {
    if (typeof params === 'number') params = { limit: params };
    const qs = new URLSearchParams();
    Object.entries(params||{}).forEach(([k,v])=>{ if(v!=null && v!=='') qs.append(k, v); });
    return request(`/axonaut/history${qs.toString()?`?${qs}`:''}`);
  },
  axonautReceptions: (params) => {
    const qs = new URLSearchParams();
    Object.entries(params||{}).forEach(([k,v])=>{ if(v!=null && v!=='') qs.append(k, v); });
    return request(`/axonaut/receptions${qs.toString()?`?${qs}`:''}`);
  },
  axonautReceptionDetail: (numero) => request(`/axonaut/receptions/${encodeURIComponent(numero)}`),
  axonautNextReception: () => request('/axonaut/next-reception'),
  axonautCancelHistory: (id) => request(`/axonaut/history/${id}/cancel`, { method: 'POST' }),
  axonautAFacturer: () => request('/axonaut/a-facturer'),
  // Inventaire collaboratif
  inventaireGetSession: () => request('/inventaire/session'),
  inventaireGetSessions: () => request('/inventaire/sessions'),
  inventaireStartSession: (commentaire) => request('/inventaire/session', { method: 'POST', body: JSON.stringify({commentaire}) }),
  inventaireGetLignes: (sessionId) => request(`/inventaire/lignes${sessionId?`?session_id=${sessionId}`:''}`),
  inventaireAddLigne: (data) => request('/inventaire/lignes', { method: 'POST', body: JSON.stringify(data) }),
  inventaireUpdateLigne: (id, data) => request(`/inventaire/lignes/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  inventaireDeleteLigne: (id) => request(`/inventaire/lignes/${id}`, { method: 'DELETE' }),
  inventaireCloseSession: (id) => request(`/inventaire/session/${id}/close`, { method: 'POST' }),
  inventaireCancelSession: (id) => request(`/inventaire/session/${id}/cancel`, { method: 'POST' }),
  inventaireResetStocks: () => request('/inventaire/reset-stocks', { method: 'POST' }),
  inventaireGetClosedSessions: () => request('/inventaire/sessions/closed'),
  inventaireGetSessionResults: (id) => request(`/inventaire/session/${id}/results`),
  inventaireRetrySession: (id) => request(`/inventaire/session/${id}/retry`, { method: 'POST' }),
  inventaireImportCsvStream: (data, onEvent) => ndjsonStream('/inventaire/import-csv', data, onEvent),
  inventaireCloseSessionStream: (id, onEvent) => ndjsonStream(`/inventaire/session/${id}/close`, {}, onEvent),
  forceReconduction: () => request('/contrats/run-reconduction', { method: 'POST' }),
  // NAS clients per planning slot
  addNasClient: (planningId, data) => request(`/planning/${planningId}/nas-client`, { method: 'POST', body: JSON.stringify(data) }),
  deleteNasClient: (id) => request(`/planning/nas-client/${id}`, { method: 'DELETE' }),
  // Installations client
  getInstallationsClient: () => request('/installations-client'),
  addInstallationClient: (data) => request('/installations-client', { method: 'POST', body: JSON.stringify(data) }),
  updateInstallationClient: (id, data) => request(`/installations-client/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteInstallationClient: (id) => request(`/installations-client/${id}`, { method: 'DELETE' }),
  // Modifications (delta-based)
  getModifications: (contratId) => request(`/contrats/${contratId}/modifications`),
  createModification: (contratId, d) => request(`/contrats/${contratId}/modifications`, { method: 'POST', body: JSON.stringify(d) }),
  updateModification: (id, d) => request(`/modifications/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteModification: (id) => request(`/modifications/${id}`, { method: 'DELETE' }),
  getAllModifications: () => request('/modifications'),
  // Users
  getUsers: () => request('/users'),
  createUser: (d) => request('/users', { method: 'POST', body: JSON.stringify(d) }),
  updateUser: (id, d) => request(`/users/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  updateUserPassword: (id, pw) => request(`/users/${id}/password`, { method: 'PUT', body: JSON.stringify({ password: pw }) }),
  deleteUser: (id) => request(`/users/${id}`, { method: 'DELETE' }),
  unlockUser: (id) => request(`/users/${id}/unlock`, { method: 'POST' }),
  getActiveUsers: () => request('/users/active'),
  assignContrat: (id, userId) => request(`/contrats/${id}/assign`, { method: 'PUT', body: JSON.stringify({ assigned_to: userId }) }),
  // NAS DAKARA
  getNas: () => request('/nas'),
  createNas: (d) => request('/nas', { method: 'POST', body: JSON.stringify(d) }),
  updateNas: (id, d) => request(`/nas/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteNas: (id) => request(`/nas/${id}`, { method: 'DELETE' }),
  // Planning sauvegarde
  getPlanning: (nasId) => request(`/planning${nasId ? `?nas_id=${nasId}` : ''}`),
  createPlanning: (d) => request('/planning', { method: 'POST', body: JSON.stringify(d) }),
  updatePlanning: (id, d) => request(`/planning/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deletePlanning: (id) => request(`/planning/${id}`, { method: 'DELETE' }),
  // Verifications sauvegarde
  getVerifications: (filters={}) => { const p=new URLSearchParams(); if(filters.client_id) p.set('client_id',filters.client_id); if(filters.nas_id) p.set('nas_id',filters.nas_id); const qs=p.toString(); return request(`/verifications${qs?'?'+qs:''}`); },
  getClientsSauvegarde: () => request('/verifications/clients-sauvegarde'),
  saveOrdreClientsSauvegarde: (order) => request('/verifications/ordre-clients', { method: 'PUT', body: JSON.stringify({ order }) }),
  createVerification: (d) => request('/verifications', { method: 'POST', body: JSON.stringify(d) }),
  updateVerification: (id, d) => request(`/verifications/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteVerification: (id) => request(`/verifications/${id}`, { method: 'DELETE' }),
  // Export & Reset
  resetAllData: () => request('/admin/reset', { method: 'POST', body: JSON.stringify({ confirm: 'RESET_CONFIRM' }) }),
  // Settings SMTP
  getSmtpSettings: () => request('/settings/smtp'),
  revealSmtpPass: () => request('/settings/smtp/reveal-pass'),
  saveSmtpSettings: (d) => request('/settings/smtp', { method: 'PUT', body: JSON.stringify(d) }),
  testSmtp: (to) => request('/settings/smtp/test', { method: 'POST', body: JSON.stringify({ to }) }),
  // Settings SSL
  getSslSettings: () => request('/settings/ssl'),
  saveSslSettings: (d) => request('/settings/ssl', { method: 'PUT', body: JSON.stringify(d) }),
  renewSslCert: () => request('/settings/ssl/renew', { method: 'POST' }),
  saveHttpPort: (d) => request('/settings/http-port', { method: 'PUT', body: JSON.stringify(d) }),
  // Backups
  getBackups: () => request('/admin/backups'),
  createBackup: () => request('/admin/backups', { method: 'POST' }),
  restoreBackup: (filename) => request('/admin/backups/restore', { method: 'POST', body: JSON.stringify({ filename }) }),
  deleteBackup: (filename) => request(`/admin/backups/${encodeURIComponent(filename)}`, { method: 'DELETE' }),
  // Commandes
  getCommandes: () => request('/commandes'),
  createCommande: (d) => request('/commandes', { method: 'POST', body: JSON.stringify(d) }),
  createCommandesBatch: (items) => request('/commandes/batch', { method: 'POST', body: JSON.stringify({ items }) }),
  updateCommande: (id, d) => request(`/commandes/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  validerCommande: (id) => request(`/commandes/${id}/valider`, { method: 'PUT' }),
  deleteCommande: (id) => request(`/commandes/${id}`, { method: 'DELETE' }),
  getFournisseursCommande: () => request('/fournisseurs-commande'),
  addFournisseurCommande: (nom) => request('/fournisseurs-commande', { method: 'POST', body: JSON.stringify({ nom }) }),
  deleteFournisseurCommande: (nom) => request(`/fournisseurs-commande/${encodeURIComponent(nom)}`, { method: 'DELETE' }),
  // Password reset (public - no auth)
  // PC & Licences
  getPcLicences: (p={}) => { const qs=Object.entries(p).filter(([,v])=>v).map(([k,v])=>`${k}=${encodeURIComponent(v)}`).join('&'); return request(`/pc-licences${qs?`?${qs}`:''}`); },
  getPcFilters: () => request('/pc-licences/filters'),
  createFournisseurPc: (nom) => request('/fournisseurs-pc', { method: 'POST', body: JSON.stringify({ nom }) }),
  deleteFournisseurPc: (nom) => request(`/fournisseurs-pc/${encodeURIComponent(nom)}`, { method: 'DELETE' }),
  createFournisseurLicence: (nom) => request('/fournisseurs-licence', { method: 'POST', body: JSON.stringify({ nom }) }),
  deleteFournisseurLicence: (nom) => request(`/fournisseurs-licence/${encodeURIComponent(nom)}`, { method: 'DELETE' }),
  createPcBatch: (items) => request('/pc-licences', { method: 'POST', body: JSON.stringify({ items }) }),
  updatePc: (id, d) => request(`/pc-licences/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deletePc: (id) => request(`/pc-licences/${id}`, { method: 'DELETE' }),
  getPcExtraLicences: (pcId) => request(`/pc-licences/${pcId}/licences`),
  addPcExtraLicence: (pcId, d) => request(`/pc-licences/${pcId}/licences`, { method: 'POST', body: JSON.stringify(d) }),
  deletePcExtraLicence: (id) => request(`/pc-extra-licences/${id}`, { method: 'DELETE' }),
  // LOA
  getLoa: (p={}) => { const qs=Object.entries(p).filter(([,v])=>v).map(([k,v])=>`${k}=${encodeURIComponent(v)}`).join('&'); return request(`/loa${qs?`?${qs}`:''}`); },
  getLoaStats: () => request('/loa/stats'),
  createLoa: (d) => request('/loa', { method: 'POST', body: JSON.stringify(d) }),
  updateLoa: (id, d) => request(`/loa/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteLoa: (id) => request(`/loa/${id}`, { method: 'DELETE' }),
  getPartenairesLoa: () => request('/partenaires-loa'),
  createPartenaireLoa: (nom) => request('/partenaires-loa', { method: 'POST', body: JSON.stringify({ nom }) }),
  deletePartenaireLoa: (id) => request(`/partenaires-loa/${id}`, { method: 'DELETE' }),
  // Gages
  getGages: () => request('/gages'),
  createGage: (label) => request('/gages', { method: 'POST', body: JSON.stringify({ label }) }),
  deleteGage: (id) => request(`/gages/${id}`, { method: 'DELETE' }),
  getConnerieHistorique: () => request('/connerie-historique'),
  createConnerieHistorique: (user_name, gage_label, user_id) => request('/connerie-historique', { method: 'POST', body: JSON.stringify({ user_name, gage_label, user_id }) }),
  setGageExecute: (id, execute) => request(`/connerie-historique/${id}/execute`, { method: 'PUT', body: JSON.stringify({ execute }) }),
  getLogo: () => fetch('/api/settings/logo').then(r=>r.json()),
  // Contrats à traiter
  getContratsATraiter: () => request('/contrats-a-traiter'),
  getContratsAFacturer: () => request('/contrats-a-facturer'),
  updateContratATraiter: (id, d) => request(`/contrats-a-traiter/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteContratATraiter: (id) => request(`/contrats-a-traiter/${id}`, { method: 'DELETE' }),
  convertContratATraiter: (id) => request(`/contrats-a-traiter/${id}/convert`, { method: 'POST' }),
  getWebhookUrl: () => request('/settings/webhook-url'),
  forgotPassword: (email) => fetch('/api/auth/forgot-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) }).then(r => r.json()),
  resetPassword: (token, password) => fetch('/api/auth/reset-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password }) }).then(r => r.json()),
  // NAS Surveillance (Télémétrie)
  getNasSurveillance: () => request('/nas-surveillance'),
  updateNasSurveillance: (id, d) => request(`/nas-surveillance/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteNasSurveillance: (id) => request(`/nas-surveillance/${id}`, { method: 'DELETE' }),
  getNasSurveillanceConfig: () => request('/nas-surveillance/config'),
  regenerateNasSurveillanceKey: () => request('/nas-surveillance/config/regenerate', { method: 'POST' }),

  // SORON (ecran de supervision)
  getSoronConfig: () => request('/soron/config'),
  saveSoronConfig: (data) => request('/soron/config', { method: 'PUT', body: JSON.stringify(data) }),
  regenerateSoronKey: () => request('/soron/config/regenerate', { method: 'POST' }),
  testSoronPush: () => request('/soron/test-push', { method: 'POST' }),
  getUsersActiveNames: () => request('/users/active-names'),
  // Configurations PC (calculateur)
  getConfigs: () => request('/configs'),
  getConfig: (id) => request(`/configs/${id}`),
  createConfig: (d) => request('/configs', { method: 'POST', body: JSON.stringify(d) }),
  updateConfig: (id, d) => request(`/configs/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteConfig: (id) => request(`/configs/${id}`, { method: 'DELETE' }),
  duplicateConfig: (id) => request(`/configs/${id}/duplicate`, { method: 'POST' }),
  getUsersActive: () => request('/users/active'),
  // Tableau de bord personnalisable
  getDashboardLayout: () => request('/dashboard/layout'),
  saveDashboardLayout: (d) => request('/dashboard/layout', { method: 'PUT', body: JSON.stringify(d) }),
  resetDashboardLayout: () => request('/dashboard/layout', { method: 'DELETE' }),
  // CRM — opportunites
  getOpportunites: (p={}) => request('/opportunites' + (Object.keys(p).length ? '?' + new URLSearchParams(p) : '')),
  createOpportunite: (d) => request('/opportunites', { method: 'POST', body: JSON.stringify(d) }),
  updateOpportunite: (id, d) => request(`/opportunites/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteOpportunite: (id) => request(`/opportunites/${id}`, { method: 'DELETE' }),
  gagnerOpportunite: (id, d) => request(`/opportunites/${id}/gagnee`, { method: 'POST', body: JSON.stringify(d) }),
  perdreOpportunite: (id, d) => request(`/opportunites/${id}/perdue`, { method: 'POST', body: JSON.stringify(d) }),
  rouvrirOpportunite: (id) => request(`/opportunites/${id}/rouvrir`, { method: 'POST' }),
  getHistoriqueOpportunite: (id) => request(`/opportunites/${id}/historique`),
  creerClientOpportunite: (id) => request(`/opportunites/${id}/creer-client`, { method: 'POST' }),
  // Taches — getTaches(true) = les miennes ; getTaches({ pour, statut, opportunite_id, avec_opps })
  getTaches: (p) => request('/taches' + (p === true ? '?mine=1' : (p && typeof p === 'object' && Object.keys(p).length ? '?' + new URLSearchParams(p) : ''))),
  rechercherLiens: (q) => request('/liens?q=' + encodeURIComponent(q)),
  createTache: (d) => request('/taches', { method: 'POST', body: JSON.stringify(d) }),
  updateTache: (id, d) => request(`/taches/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteTache: (id) => request(`/taches/${id}`, { method: 'DELETE' }),
  reorderTaches: (ids) => request('/taches/reorder', { method: 'POST', body: JSON.stringify({ ids }) }),
  setInstallationStatut: (id, statut) => request(`/installations-client/${id}/statut`, { method: 'PATCH', body: JSON.stringify({ statut }) }),
  // Agents IA (MCP) — admin
  getAgents: () => request('/agents'),
  saveAgentsConfig: (d) => request('/agents/config', { method: 'PUT', body: JSON.stringify(d) }),
  saveClaudeConfig: (d) => request('/agents/claude', { method: 'PUT', body: JSON.stringify(d) }),
  createAgent: (d) => request('/agents', { method: 'POST', body: JSON.stringify(d) }),
  updateAgent: (id, d) => request(`/agents/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  regenererAgent: (id) => request(`/agents/${id}/regenerer`, { method: 'POST' }),
  deleteAgent: (id) => request(`/agents/${id}`, { method: 'DELETE' }),
  getAgentsJournal: () => request('/agents/journal'),
  annulerAgentJournal: (id) => request(`/agents/journal/${id}/annuler`, { method: 'POST' }),
  // Mémoire des agents IA (page 🧠 Mémoire)
  getMemoire: (p) => request('/memoire' + (p && Object.keys(p).length ? '?' + new URLSearchParams(p) : '')),
  getMemoireCompteurs: () => request('/memoire/compteurs'),
  createMemoire: (d) => request('/memoire', { method: 'POST', body: JSON.stringify(d) }),
  updateMemoire: (id, d) => request(`/memoire/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  deleteMemoire: (id, definitif) => request(`/memoire/${id}${definitif ? '?definitif=1' : ''}`, { method: 'DELETE' }),
  restaurerMemoire: (id) => request(`/memoire/${id}/restaurer`, { method: 'POST' }),
  configPdfUrl: (id) => `${API_BASE}/configs/${id}/pdf`,
};
